import { createApp } from 'vue'
import Radian from './Radian.vue'
import './assets/global.css'

createApp(Radian).mount('#radian')
